/* eslint-disable no-use-before-define,no-eval */
import { ajax, cleanObject, toQueryString, } from '../twd/twd'
import { STEPS, MODES } from './use-order-ticket'

export const preview = async ({
    step, acctNo, action, cusip, qty, price, yld, priceOrYield,
    isRfq, isCalc, attested, hasMarket,
    hasOrderInfo, orderInfo, hiddenState, setOrderInfo, setHiddenState,
    sourceAction_, actionSubset_, sourceOrderNo_,
    isTreasuryAuction, bestPrice, bestYield,
    mode,
}) => {

    const f = step===STEPS.ENTRY
        && qty
        && (isRfq || price || yld || !hasMarket || isTreasuryAuction)
        && hasOrderInfo
    if (!f) {
        return
    }

    const { dealerCode:p_dealer_code, tradeType:p_trade_type, settlement:p_settlement, statusMsg } = orderInfo
    const {
        p_price_init, p_yield_init, p_discount_init, p_settlement_init, p_id, p_order_type,
        p_wrap_acct, p_exec_type, p_seeded, p_validated, p_warning,
        p_mm, p_dd, p_yy, p_old_dlr_price, p_timestamp, p_validate_resp, p_valreq_id,
        p_order_trans_id, p_ocfg_order_no,
    } = hiddenState
    const isLift = mode === MODES.ORDER_Z
    const isCounterDisallowed = orderInfo && orderInfo.countersAllowed==='N'

    let params = cleanObject({
        // user-entered
        p_acct_no: acctNo,
        p_action: isTreasuryAuction ? 'B' : action,
        p_cusip: cusip,
        p_qty_bond: qty,
        p_price: isTreasuryAuction ? null
            : isCounterDisallowed ? bestPrice
            : price,
        p_yield: isTreasuryAuction ? null
            : isCounterDisallowed ? bestYield
            : yld,
        p_price_type: isTreasuryAuction ? 'A' : priceOrYield,
        p_misc4: isCalc || attested ? 'Y' : '',

        // from hidden-states
        p_dd,
        p_dealer_code,
        p_discount_init,
        p_exec_type,
        p_id,
        p_mm,
        p_ocfg_order_no: isLift ? '' : p_ocfg_order_no,
        p_old_dlr_price,
        p_order_trans_id,
        p_order_type: isTreasuryAuction ? 'A' : p_order_type,
        p_price_init: isLift ? price : p_price_init,
        p_seeded: isTreasuryAuction ? 1 : p_seeded,
        p_settlement,
        p_settlement_init,
        p_timestamp,
        p_trade_type,
        p_validated: statusMsg && statusMsg.toLowerCase().indexOf('click preview to continue')>=0 ? 'Y' : p_validated,
        p_validate_resp,
        p_valreq_id,
        p_warning,
        p_wrap_acct,
        p_yield_init,
        p_yy,

        // from origin actionSubset_, sourceOrderNo_
        p_action_subset: actionSubset_,
        p_source_order_no: sourceOrderNo_,
        p_source_action: sourceAction_,

        // p_alloc_id: '',
        // p_broker_text: '',
        // p_called_from: '',
        // p_dtc: '',
        // p_execbroker: '',
        // p_javascript: '',
        // p_limittext: '',
        // p_markup_quantity: '',
        // p_max_bid_sc: '',
        // p_miscdata: '',
        // p_order_xref: '',
        // p_ovalcdata: '',
        // p_price_change_ind: '',
        // p_settlement_ent_val: '',
        // p_ticket_source: '',

        p_output_format: 'JSON',
        p_transdata: 'ETRADENOE(Y)',
        p_submit: 'Preview Order',
    })

    try {
        const { data:order_ } = await ajax({
            url: '/esb/portfolio/trades/orderInput',
            method: 'POST',
            headers_: {
                'Content-Type': 'text/plain'
            },
            body: toQueryString(params).replace('%20', '+'),
            type: 'text',
        })

        const info = eval(await order_)
        if (isCalc) {
            return info
        }

        info.executionType = info.primary === 'Y' ? 'Firm' : info.executionType

        if (info.statusMsg) {
            info.statusMsg = info.statusMsg.replace(
            'Click Save & Preview or Save & Enter Another Account',
            'Click Preview')
        }

        if (info.hiddenState && info.statusMsg && info.statusMsg.toLowerCase().indexOf('click preview to continue')>=0) {
            Object.assign(hiddenState, info.hiddenState)
            info.status = 'Alert'
            setHiddenState({ ...hiddenState, })
        }

        return setOrderInfo(info)
        // return info
    } catch(e) {
        Object.assign(orderInfo, {
            status: 'Fail',
            statusMsg: 'ERROR: There was an error processing your request.'
        })
        console.error('use-order-ticket-preview', e)
    }

}
